import React, { type ReactNode } from "react";

import clsx from "clsx";

interface Props {
  children: ReactNode;
  active?: boolean;
  onClick(): void;
}

export const Tab = ({ children, active, onClick }: Props) => {
  return (
    <div
      onClick={onClick}
      className={clsx(
        "flex items-center cursor-pointer z-[2] h-11 justify-center",
        {
          "text-v2-secondary": !active,
          "hover:bg-v2-secondary hover:text-primary hover:rounded": !active,
          "bg-v2-primary border-b-v2-primary": active,
        },
      )}
    >
      <div
        className={clsx("flex-1 h-full items-center flex px-3", {
          "text-primary font-semibold border-b-2 border-v2-action ": active,
        })}
      >
        {children}
      </div>
    </div>
  );
};
